import React, { useState } from "react"
import LessonDeleteModal from "./LessonDeleteModal"
import "./Lesson.css"

function Lesson({ data, handleEdit, handleDelete }) {
    return (
        <div className="lesson">
            <div className="lesson-container">
                <div className="lesson-left">
                    <div className="lesson-year">{data.year}</div>
                </div>
                <div className="lesson-right">
                    <div className="lesson-right-column-one">
                        <div className="lesson-date">{data.dateOfMeeting}</div>
                        <div className="lesson-hour">{data.timeOfMeeting}</div>
                    </div>
                    <div className="lesson-right-column-two">
                        <div className="lesson-subject">{data.subject}</div>
                    </div>
                    <div className="lesson-right-column-three">
                        <div className="lesson-group">{data.studentBatch}</div>
                        <div className="lesson-teacher">{data.professor}</div>
                    </div>
                </div>
                <div className="lesson-buttons">
                    <span onClick={handleEdit}>
                        <i className="fas fa-edit fa-2x"></i>
                    </span>
                    <span onClick={handleDelete}>
                        <i className="fas fa-trash fa-2x"></i>
                    </span>
                </div>
            </div>

            {/* {deleteModal && (
                <DeleteModal
                    deleteModal={deleteModal}
                    setDeleteModal={setDeleteModal}
                    deleteLesson={deleteLesson}
                    id={id}
                />
            )} */}
        </div>
    );
}

export default Lesson;
